import request from '@/utils/request'

export function queryOperationOverview(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/report.queryOperationOverview',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取经营概览数据失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
